import { ChecklistForm } from "@/components/checklists/checklist-form";
import { Button } from "@/components/core/buttons/button";
import { Content } from "@/components/layouts/content";
import { useChecklistCreateMutation } from "@/features/dashboard/api/queries/checklist-query";
import type { Checklist } from "@/features/dashboard/types/checklist";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";

export const Route = createFileRoute("/_dashboard/checklists_/create")({
	component: Page,
});

function Page() {
	const navigate = useNavigate();
	const [isSubmitting, setIsSubmitting] = useState(false);
	const createMutation = useChecklistCreateMutation();

	const handleSubmit = async (values: Checklist) => {
		setIsSubmitting(true);
		try {
			const response = await createMutation.mutateAsync(values);
			toast.success("Checklist created successfully");
			await navigate({ to: `/checklists/${response.id}` });
		} catch (error) {
			console.log(error);
			toast.error("Failed to create checklist");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Content pageName="Create Checklist">
			<div className="flex flex-col w-full max-w-4xl mx-auto p-6 gap-6">
				<div className="flex flex-row items-center justify-between w-full gap-4">
					<div className="inline-flex flex-col w-auto">
						<span className="text-xl text-foreground-dark font-semibold">Create New Checklist</span>
						<span className="text-base text-foreground/70">Add a new checklist for project management</span>
					</div>
				</div>

				<div className="bg-white rounded-lg border p-6">
					<ChecklistForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />

					<div className="flex justify-end gap-2 mt-6 pt-6 border-t">
						<Button type="button" variant="ghost" onClick={() => navigate({ to: "/checklists" })} disabled={isSubmitting}>
							Cancel
						</Button>
						<Button
							type="submit"
							form="checklist-form"
							disabled={isSubmitting}
							onClick={() => {
								const form = document.querySelector("#checklist-form") as HTMLFormElement;
								if (form) {
									form.requestSubmit();
								}
							}}
						>
							{isSubmitting ? "Creating..." : "Create Checklist"}
						</Button>
					</div>
				</div>
			</div>
		</Content>
	);
}
